// extracted by mini-css-extract-plugin
export default {"header":"mobile_header__NN1Oe"};